import { render, staticRenderFns } from "./ResultList.vue?vue&type=template&id=798a237f&"
import script from "./ResultList.vue?vue&type=script&lang=ts&"
export * from "./ResultList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports